import React, { Suspense, useEffect } from "react";
import { Layout } from "antd";
import { Outlet } from "react-router-dom";
import HeaderComponent from "components/Common/Header/Header";
import { FooterComponent } from "components/Common/Footer/Footer";
import "./MainLayout.scss";
import { useAppSelector } from "hooks/reduxHooks";
import { LazyLoader } from "components/Common/LazyLoader/LazyLoader";

const { Content } = Layout;

const MainLayout: React.FC = () => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const lockerDetails: any = useAppSelector((state) => state.landingPage.lockerPortalDetails);

  const lockerDetailsPortal = async () => {
    if (lockerDetails && lockerDetails?.lockerPortalDetails?.FaviconUrl) {
      if (lockerDetails?.lockerPortalDetails?.WebsiteTitle)
        document.title = lockerDetails?.lockerPortalDetails?.WebsiteTitle;
      const f_icon = document.getElementById("custom_favicon");
      if (f_icon) {
        f_icon.setAttribute("href", lockerDetails?.lockerPortalDetails?.FaviconUrl);
      }
    }
  };

  useEffect(() => {
    lockerDetailsPortal();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lockerDetails]);
  
  return (
    <>
      <HeaderComponent />
      <Layout className="site-layout">
        <Content className="content-container">
          <Suspense fallback={<LazyLoader />}>
            <Outlet />
          </Suspense>
        </Content>
      </Layout>
      <FooterComponent />
    </>
  );
};

export default MainLayout;
